import {Injector} from '@angular/core';
import * as _ from 'lodash-es';
import {addPoints, Dimension, Point} from '../layout/abstract-units';
import {CellActionType} from '../layout/layout-actions/cell-action-type';
import {LayoutBase} from '../layout/layout-base';
import {LayoutChanges} from '../layout/layout-changes';
import {Widget} from '../layout/widget/widget';
import {FloatCell, FloatCellDisplayInfo} from './float-cell';

export class FloatLayout extends LayoutBase {

    public override cells: FloatCell[];

    constructor(
        size: Point,
        tabId: string,
        cells: FloatCell[],
        widgets: Widget[],
        injector: Injector
    ) {
        super(size, tabId, cells, widgets, injector);

        console.log('[FloatLayout] Initialization', {cells: this.cells});
    }

    public override produceDisplayInfo(displaySize: Point): void {
        this.displaySize = displaySize.slice() as Point;

        this.updateCellsDisplayInfo();
    }

    public override updateCellsDisplayInfo(cells?: FloatCell[]): void {
        cells = cells || this.cells;

        cells.forEach(cell => {
            const [x, y] = cell.pos;
            const displayPos: Point = [
                x && this.calcDisplayDimension(x, Dimension.X),
                y && this.calcDisplayDimension(y, Dimension.Y)
            ];
            const displaySize: Point = cell.size.slice() as Point;

            const displayInfo: FloatCellDisplayInfo = cell.display = cell.display || {
                pos:       null,
                nextPos:   null,
                size:      null,
                wireframe: null
            };

            displayInfo.pos = displayPos;
            displayInfo.nextPos = addPoints(displayPos, displaySize);
            displayInfo.size = displaySize;
        });
    }

    public override setLayoutSize(newLayoutSize: Point): void {
        super.setLayoutSize(newLayoutSize);

        this.cells.forEach(cell => {
            if (cell.display && cell.display.pos) {
                cell.pos = cell.display.pos.slice() as Point;
            }
        });
    }

    public removeWidget(widget: Widget): LayoutChanges {
        const changes: LayoutChanges = new LayoutChanges();
        const cell: FloatCell = widget.cell as FloatCell;

        if (cell) {
            _.pull(cell.widgets, widget);

            if (cell.activeWidget === widget) {
                cell.activeWidget = cell.widgets[0] || null;
            }

            changes.add(
                'Widget removed',
                {widget},
                {actionType: CellActionType.WIDGET_DELETE}
            );

            if (!cell.widgets.length) {
                changes.add(
                    'Cell removed',
                    {cell},
                    {actionType: CellActionType.CELL_DELETE}
                );
            }
        }

        return changes;
    }

    public bringCellToFront(cell: FloatCell): void {
        const cellIndex: number = this.cells.indexOf(cell);

        if (cellIndex >= 0 && cellIndex < this.cells.length - 1) {
            this.cells.splice(cellIndex, 1);
            this.cells.push(cell);

            const changes: LayoutChanges = new LayoutChanges()
                .add(
                    'Float cell brought to front',
                    {cell},
                    {actionType: CellActionType.CELL_CHANGE}
                );

            this.commitChanges(changes);
        }
    }

    public setCellDisplayPos(cell: FloatCell, newDisplayPos: Point): LayoutChanges {
        const changes = new LayoutChanges();
        const [x, y] = newDisplayPos;

        if (x !== null || y !== null) {
            this.setLayoutSize(this.displaySize); // Set normal dimensions to be equal to display ones.

            cell.pos = [x, y];

            this.updateCellsDisplayInfo([cell]);

            changes.add(
                'Float cell moved',
                {cell},
                {actionType: CellActionType.CELL_CHANGE}
            );
        }

        return changes;
    }

}
